var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.paper},[_c('img',{attrs:{"src":_vm.imageUrl,"height":"100%"}}),_c('span',{staticClass:"description"},_vm._l((_vm.descText),function(desc,index){return _c('div',{key:index,staticClass:"description"},[_vm._v("\n    "+_vm._s(desc)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }